export interface StaticRedirect {
  from: string;
  to: string;
}

export const STATIC_REDIRECTS: StaticRedirect[] = [
  {
    from: "/octant/applets",
    to: "/octant",
  },
  {
    from: "/leading-content-giant",
    to: "/blog/leading-content-giant",
  },
  {
    from: "/leading_content_giant",
    to: "/blog/leading-content-giant",
  },
  {
    from: "/content-giant",
    to: "/blog/leading-content-giant",
  },
  {
    from: "/blog/content_giant_case_study",
    to: "/blog/leading-content-giant",
  },
  {
    from: "/blog/leading_content_giant",
    to: "/blog/leading-content-giant",
  },
  {
    from: "/blog/content-giant",
    to: "/blog/leading-content-giant",
  },
  {
    from: "/case-study/content_giant_case_study",
    to: "/case-study/leading-content-giant",
  },
  {
    from: "/case-study/content-giant",
    to: "/case-study/leading-content-giant",
  },
  {
    from: "/case-study/leading_content_giant",
    to: "/case-study/leading-content-giant",
  },
];

export const STATIC_REDIRECTS_BY_SOURCE = STATIC_REDIRECTS.reduce<
  Record<string, string>
>((accum, redirect) => {
  accum[redirect.from] = redirect.to;
  return accum;
}, {});

export function resolveRedirectPath(path: string): string {
  const visited = new Set<string>();
  let current = path;

  while (STATIC_REDIRECTS_BY_SOURCE[current] && !visited.has(current)) {
    visited.add(current);
    current = STATIC_REDIRECTS_BY_SOURCE[current];
  }

  return current;
}
